<!--
  @Description: 我的关注
  @Author: wang.y 
  @Date: 2022-02-25 
-->
<template>
  <div class="my-attention">
    <DataNavigation></DataNavigation>
    <div class="attention">
      <div class="attention-top">
        <div class="atten-type">
          <div :class="{'on': active_type == 1}" @click="handleClickActive(1)">关注的公司</div>
          <div :class="{'on': active_type == 2}" @click="handleClickActive(2)">关注的机构</div>
        </div>
        <div class="search">
          <search-entity></search-entity>
        </div>
      </div>
      <!-- 关注的公司 -->
      <div class="content" v-if="active_type == 1">
        <CompData v-if="init_atten_comp.length"></CompData>
        <CompNoData v-else></CompNoData>
      </div>
      <!-- 关注的机构 -->
      <div class="content" v-if="active_type == 2">
        <OrgData v-if="init_atten_org.length"></OrgData>
        <OrgNoData v-else></OrgNoData>
      </div>
      <Recommend :orglist="org_reco_list" :complist="comp_reco_list"></Recommend>
    </div>
  </div>
</template>
<script>
import { recommend, findEntity, commonStarOrgList, subscribeList, getMeta } from '@/service'
import DataNavigation from '@/components/DataNavigation'
import CompNoData from './components2/CompNoData'
import CompData from './components2/CompData'
import OrgNoData from './components2/OrgNoData'
import OrgData from './components2/OrgData'
import Recommend from './components2/Recommend'
import SearchEntity from './components2/SearchEntity'
export default {
  components: {
    DataNavigation, CompNoData, CompData, Recommend, OrgNoData, OrgData, SearchEntity
  },
  created() {
    this.getMeta()
    this.getRecommend()
    this.init_atten_comp = this.$store.state.attention.subscribe.filter(a => a.sub_type == '0')
    this.init_atten_org = this.$store.state.attention.subscribe.filter(a => a.sub_type == '1')
  },
  mounted() {

  },
  data() {
    return {
      active_type: 1,
      comp_reco_list: [],
      org_reco_list: [],
      atten_comp: [],
      atten_comp_ids: [],
      atten_org: [],
      atten_org_ids: [],
      init_atten_comp: [],
      init_atten_org: [],
      entity_ntag: []
    }
  },
  computed: {

  },
  methods: {
    async getMeta() {
      let res = await getMeta({name: ['entity_ntag']},(error) => {
        this.$Message.error('元数据请求错误！')
      })
      if (res.status == 'success') {
        this.entity_ntag = res.meta.entity_ntag
      }
    },
    // 获取关注信息
    async getSubscribeList() {
      let res = await subscribeList({
        user_key: this.$store.state.user_key
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$store.commit('updateFilter', {
          g_relation: res.g_relation,
          group: res.group,
          subscribe: res.subscribe
        })
        this.init_atten_comp = res.subscribe.filter(a => a.sub_type == '0')
        this.init_atten_org = res.subscribe.filter(a => a.sub_type == '1')
      } else {
        this.$Message.error(res.msg)
      }
    },
    handleClickActive(type) {
      this.active_type = type
      this.init_atten_comp = this.$store.state.attention.subscribe.filter(a => a.sub_type == '0')
      this.init_atten_org = this.$store.state.attention.subscribe.filter(a => a.sub_type == '1')
      if(type == 1) {
        _czc.push(['_trackEvent', '我的关注(新)', '关注的公司切换按钮', '点击量'])
      } else {
        _czc.push(['_trackEvent', '我的关注(新)', '关注的机构切换按钮', '点击量'])
      }
    },
    async getRecommend() {
      let res = await recommend({
        page: 1,
        type: 0,
        user_key: this.$store.state.user_key
      }, (error) => {
        this.$Message.error('请求错误！')
      })

      if (res.status == 'success') {
        this.$set(this.$data, 'comp_reco_list', res.res)
      } else {
        this.$Message.error(res.message)
      }

      let res2 = await commonStarOrgList({
        user_key: this.$store.state.user_key
      }, (error) => {
        this.$Message.error('请求错误！')
      })

      if (res2.msg == 'success') {
        this.$set(this.$data, 'org_reco_list', res2.data)
      } else {
        this.$Message.error(res2.msg)
      }
    },
    goEntityDetail(type, uid) {
      if (type == 1) {
        const { href } = this.$router.resolve({ name: "OrgDetail", params: { uid: uid } })
        window.open(href, '_blank')
      } else if (type == 0) {
        _czc.push(['_trackEvent', '我的关注(新)', '关注的公司(公司研究_更多)', '点击量'])
        const { href } = this.$router.resolve({ name: "CompanyDetail", params: { uid: uid } })
        window.open(href, '_blank')
      }
    },
    //跳转至文章、视频、快讯、专题详情
    goToDetail(item) {
      console.log(item)
      switch (item.content_type) {
        case 0:
          const temp_href = this.$store.state.index2_path + '/' + item.content_id
          window.open(temp_href, '_blank')
          break;
        case 1:
          const temp_href1 = this.$store.state.index2_path + '/' + item.content_id
          window.open(temp_href1, '_blank')
          break
        case 3:
          const { href } = this.$router.resolve({ name: "SpecialDetail", params: { uid: item.uid } })
          window.open(href, '_blank')
          break;
        case 2:
          const { href2 } = this.$router.resolve({ name: "ReportDetail", params: { uid: item.uid } })
          window.open(href2, '_blank')
          break;
        case 4:
          const href3 = this.$store.state.index2_path + '/newsDetail/' + item.uid
          window.open(href3, '_blank')
          break;
      }
    },
    //跳转至赛道详情
    goToTrackDetail(id) {
      const { href } = this.$router.resolve({ name: 'trackDetail', query: { tag: id } })
      window.open(href, '_blank')
    },
    handleChangeRouter(router_name) {
      const { href } = this.$router.resolve({ name: router_name })
      window.open(href, '_blank')
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.my-attention
  background #fff
  display flex
  justify-content center
  min-width 1200px
  >>> .ivu-spin
    color #FA5A00
  .attention
    margin-left 20px
    padding 20px 0
    width 1090px
    .attention-top
      display flex
      justify-content space-between
    .atten-type
      display flex
      div
        font-size 20px
        position relative
        line-height 1
        height 20px
        z-index 1
        color #999999
        cursor pointer
        &+div
          margin-left 30px
        &.on
          color #333333
          &::before
            content ''
            position absolute
            background rgba(255, 186, 128, 1)
            height 6px
            width 100%
            bottom -2px
            z-index -1
    .content
      margin-top 20px
      > div + div
        margin-top 30px
  >>> .nodata
    background #F8F9FA
    padding 50px 36px 30px
    .default-container
      text-align center
      p
        font-size 14px
        line-height 24px
        color #999
        margin-top 20px
      a
        color rgba(250, 122, 80, 1)
        text-decoration underline
    .default-atten
      margin-top 40px
      .group-list
        display flex
        > div
          height 32px
          background rgba(250, 122, 80, 0)
          border 1px solid #FA5A00
          border-radius 16px
          display flex
          justify-content center
          align-items center
          padding 0 16px
          color #FA5A00
          cursor pointer
          &.on
            background rgba(250, 122, 80, 1)
            color #fff
          &+div
            margin-left 12px
      .recommend-list
        display grid
        grid-template-columns repeat(4, 240px)
        grid-template-rows 60px
        grid-gap 16px 20px
        grid-auto-columns 240px
        grid-auto-rows 60px
        justify-content space-between
        margin-top 20px
  >>> .hava-data
    display flex
    .left
      flex 0 0 244px
      position relative
    .right
      flex 0 0 836px
      margin-left 10px
</style>